import { render, staticRenderFns } from "./NavMenuLink.vue?vue&type=template&id=efed0b32&scoped=true"
import script from "./NavMenuLink.vue?vue&type=script&lang=js"
export * from "./NavMenuLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efed0b32",
  null
  
)

export default component.exports